import { UPLOAD_ERRORS } from '@adsk/docs-js-sdk';

import { UploadError } from '../types';

export const mapValidationErrorToTranslationKey = {
  [UPLOAD_ERRORS.FILE_NAME_INVALID_CHARS]: 'FILE_NAME_INVALID',
  [UPLOAD_ERRORS.INVALID_FILE_TYPE]: 'INVALID_FILE_TYPE',
  [UPLOAD_ERRORS.FILE_NAME_END_PERIOD]: 'FILE_NAME_END_PERIOD',
  [UPLOAD_ERRORS.FILE_NAME_RESERVED]: 'FILE_NAME_RESERVED',
  [UPLOAD_ERRORS.FILE_NAME_TOO_LONG]: 'FILE_NAME_TOO_LONG',
  [UPLOAD_ERRORS.INVALID_MAT_FILE]: 'INVALID_MAT_FILE',
  [UPLOAD_ERRORS.INVALID_RVT_FILE]: 'INVALID_RVT_FILE',
} as Record<string, string>;

// rejected does not allow retry
export const REJECTED_ERROR_CODES = [
  UPLOAD_ERRORS.FILE_NAME_INVALID_CHARS,
  UPLOAD_ERRORS.INVALID_FILE_TYPE,
  UPLOAD_ERRORS.FILE_NAME_END_PERIOD,
  UPLOAD_ERRORS.FILE_NAME_RESERVED,
  UPLOAD_ERRORS.FILE_NAME_TOO_LONG,
  UPLOAD_ERRORS.INVALID_MAT_FILE,
  UPLOAD_ERRORS.INVALID_RVT_FILE,
];

export const isFileRejected = (err: unknown) => {
  if (!err) {
    return false;
  }

  console.log(err);

  if (REJECTED_ERROR_CODES.includes((err as UploadError)?.code)) {
    return true;
  }

  return false;
};
